import { render, staticRenderFns } from "./CustomerLangSelect.vue?vue&type=template&id=141862fc&"
import script from "./CustomerLangSelect.vue?vue&type=script&lang=ts&"
export * from "./CustomerLangSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports